import { Pipe, PipeTransform } from "@angular/core";
import { ObjectGroupViewModel } from "../../admin-panel/ObjectGroupViewModel";
import { IManagableObject } from "../../admin-panel/IManagableObject";
import { matchesSearchRule } from "./filterByProperty";

export class GroupFilterModel {
  public term: string;
  public group: ObjectGroupViewModel;
  public companyIds: number[] = [];
}


@Pipe({
    name: 'groupFilter',
    pure: false,
    standalone: false
})
export class FilterByNameAndGroupPipe implements PipeTransform
{
  transform(items: IManagableObject[], filter: GroupFilterModel): any
  {
    if (!items) return [];

    if (filter.term && filter.term != "") 
    {
      var filteredItems = [];
      for (let i = 0; i < items.length; i++)
        if (matchesSearchRule(items[i].Name, filter.term))
          filteredItems.push(items[i]);
        //else
          //items[i].IsChecked = false;

      items = filteredItems;
    }

    if (filter.group && filter.group.Id > 0)
    {
      let groupIDs = {};
      for (let i = 0; i < filter.group.objects.length; i++)
        groupIDs[filter.group.objects[i]] = 1;

      var filteredItems = [];
      for (let i = 0; i < items.length; i++)
        if (groupIDs[items[i].Id])
          filteredItems.push(items[i]);
        //else
          //items[i].IsChecked = false;
      items = filteredItems;
    }

    if (filter.companyIds?.length)
    {
      const selectedCompanyIds = new Set<number>(filter.companyIds);
      const filteredItems = [];
      for (let i = 0; i < items.length; i++)
        if (selectedCompanyIds.has((items[i] as IManagableObject & { CompanyId?: number }).CompanyId ?? 0))
          filteredItems.push(items[i]);
      items = filteredItems;
    }

    return items;
  }
}
